module.exports = __webpack_public_path__ + "img/login-modal-left-image.a8907f1d.png";